// * Make sure to sync with MENU_REFRESH_CART_STATUS_CODES (packages/cart-client/src/helpers/Cart.ts)
// * If a new code is added or changes are made to any existing code
export enum CART_STATUS_CODES {
    SUCCESS = 0,
    FAILURE = 1,
    LOCATION_UNSERVICEABLE = 5,
    RESTAURANT_UNSERVICEABLE = 9,
    RESTAURANT_CLOSED = 6,
    RESTAURANT_CLOSED_WITH_REOPEN_TODAY = 60,
    RESTAURANT_CLOSED_WITH_REOPEN_TOMORROW = 61,
    RESTAURANT_CLOSED_WITH_REOPEN_SPECIFIC_DAY = 62,
    RESTAURANT_CLOSED_WITH_REOPEN_IN_MINUTES = 63,
    RESTAURANT_CLOSED_WITH_NO_INFO = 64,
    RESTAURANT_CLOSED_WITH_REOPEN_SPECIFIC_DATE = 65,
    CITY_CLOSED = 48,
    ITEM_OUTOFSTOCK = 8,
    TOO_MANY_ITEMS = 11,
    ADDRESS_ID_NOT_FOUND_CART_ERROR = 10,
    EXCEEDED_INVENTORY = 13,
    PREORDER_SLOT_EXPIRED_CART_ERROR = 18,
    SUPER_SUBSCRIPTION_INVALID = 21,
    CAFE_AUTHORIZATION_ERROR_CART_ERROR = 29,
    EXTERNAL_VALIDATION_FAILED_CART_ERROR = 30,
    EDIT_ORDER_ERROR = 33,
    EDIT_ORDER_COD_LIMIT_ERROR = 1001,
    MIN_CART_VALUE_ERROR = 41,
    INCREASE_IN_DEMAND = 44,
    RAINS = 45,
    ZONE_NOT_OPEN = 46,
    BLACKZONE = 47,
    TOO_MANY_ITEMS_ON_CART = 43,
    BREAKFAST_SLOT_UNAVAILABLE = 82,
    SELECTED_SLOT_UNAVAILABLE = 83,
    BULK_ORDER_TOTAL_PRICE_IS_BELOW_THRESHOLD = 84,
    SESSION_EXPIRED = 999,
    GIFTING_FOOD_CART_FAILURE = 2,
    GIFTING_FOOD_CART_POST_ORDER_FAILURE = 86,
    // Instamart specific status codes
    IM_CART_FAILURE = 70,
    INSTAMART_ITEM_LEVEL_LIMIT_EXCEEDED = 72,
    INSTAMART_TOTAL_ITEM_LIMIT_EXCEEDED = 73,
    INSTAMART_TOTAL_WEIGHT_LIMIT_EXCEEDED = 74,
    INSTAMART_TOTAL_VOLUME_LIMIT_EXCEEDED = 75,
    // IRCTC non-PNR flow status codes (kept in sync with cart-types CART_STATUS_CODES)
    IRCTC_INVALID_PNR = 97,
    IRCTC_SEAT_NOT_CONFIRMED = 98,
    IRCTC_API_FAILURE = 89,
    IRCTC_CUT_OFF_TIME_EXPIRED = 85,
    IRCTC_STATION_NOT_IN_JOURNEY = 99,
    IRCTC_ORDER_WINDOW_LIMIT_ERROR = 100,
}

export enum GROUP_CART_STATUS_CODES {
    GROUP_CART_NO_LONGER_EXISTS = 88,
    GROUP_CART_HAS_LOCKED = 89,
    GROUP_CART_ORDER_PLACED = 94,
}

export const CART_GENERIC_EVENT_CASES = {
    EMPTY_CART: "empty_cart",
    TOO_MANY_REQUESTS: "too_many_requests",
    NETWORK_CONNECTIVITY: "network_connectivity",
    NULL_CART_RESPONSE: "null_cart_response",
    EMPTY_COUPON_LISTING_PAGE: "empty_coupon_listing_page",
    GENERIC_CART_ERROR: "generic_cart_error",
};
